import AssignmentIcon from '@mui/icons-material/Assignment'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import HeadphonesOutlinedIcon from '@mui/icons-material/HeadphonesOutlined'
import Home from '@mui/icons-material/Home'
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined'
import MonitorOutlinedIcon from '@mui/icons-material/MonitorOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import SecurityIcon from '@mui/icons-material/Security'
import SportsGolfIcon from '@mui/icons-material/SportsGolf'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import AdminIcon from '@/assets/icons/AdminIcon'
import AreaChart from '@/assets/icons/AreaChart'
import Docs from '@/assets/icons/Docs'

export const DDE_MENU_ICONS = {
  DATA_ADMIN: SecurityIcon,
  LICENSES: WorkspacePremiumIcon,
  OPERATORS: HeadphonesOutlinedIcon,
  USER_ADMIN: PeopleAltOutlinedIcon,
  DISTRIBUTION_LIST: AssignmentIcon,
  MONITORING_V1: LaunchOutlinedIcon,
  MONITORING_V2: MonitorOutlinedIcon,
  GOLF_PRICING: SportsGolfIcon
}

export const STREAMING_MENU_ICONS = {
  DASHBOARD: Home,
  CONTENT: Docs,
  ADMIN: AdminIcon,
  EVENT: CalendarMonthIcon,
  HISTORICAL_STATISTICS: AreaChart,
  OPERATORS: HeadphonesOutlinedIcon,
  USERS: PeopleAltOutlinedIcon
}
